<template>
  <b-modal
    :title="'Editar Permisos del Rol: ' + rol.nombre"
    ref="modalEditionRol"
    hide-footer
    centered
    size="lg"
  >
    <b-overlay :show="isSaving || isLoading">
      <div class="row">
        <div class="col-md-12">
          <input
            class="form-control"
            v-model="filter"
            placeholder="Buscar..."
          >
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 scroll-area">
          <ul class="list-group mt-5">
            <li
              v-for="permission in filteredPermissions"
              class="list-group-item"
              :key="permission.codigo"
            >
              <div class="row">
                <div class="col-md-10">
                  <h6 v-b-tooltip="permission.descripcion">
                    {{ permission.nombre }}
                  </h6>
                  <small class="text-muted">
                    {{ permission.codigo }} : {{ permission.accion }}
                  </small>
                </div>
                <div class="col-md-2">
                  <b-form-checkbox
                    switch
                    size="lg"
                    value="si"
                    unchecked-value="no"
                    v-model="permission.asignado"
                  ></b-form-checkbox>
                </div>
              </div>

            </li>
          </ul>
        </div>
        <div class="col-md-12">
          <button
            class="btn btn-primary"
            @click="savePermissionRol"
          >
            Guardar
          </button>
        </div>
      </div>
    </b-overlay>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';

import { applications, webSopes } from '@/febos/global/utils/configurations';
import { ioSaveCompanyRolPermission, ioListCompanyRolPermission } from '@/febos/servicios/api/empresas.api';

export default {
  name: 'RolPermissionModal',
  data() {
    return {
      applications,
      webSopes,
      filter: '',
      permissions: [],
      isSaving: false,
      isLoading: false,
      rol: {}
    };
  },
  computed: {
    ...mapGetters('Empresas', [
      'company'
    ]),
    filteredPermissions() {
      return this.permissions.filter(
        (permission) => permission.filtrable?.toLowerCase()
          .includes(this.filter?.toLowerCase())
      );
    }
  },
  methods: {
    async savePermissionRol() {
      this.isSaving = true;
      const permissions = this.permissions.filter((permission) => permission.asignado === 'si')
        .map((permission) => (
          permission.codigo
        ))
        .reduce(
          (acc, permiso) => ({
            ...acc,
            [permiso]: permiso
          }),
          {}
        );
      const { rol } = this;
      try {
        await ioSaveCompanyRolPermission(this.company.id, rol.rolId, Object.keys(permissions));
        this.$emit('saveRolPermission', this.rol);
        this.$refs.modalEditionRol.hide();
        this.isSaving = false;
      } catch (e) {
        console.error(e);
        this.isSaving = false;
      }
    },
    async open(rol) {
      this.isLoading = true;
      this.permissions = [];
      this.rol = rol;
      this.$refs.modalEditionRol.show();
      const { data } = await ioListCompanyRolPermission(this.company.id, rol.rolId);
      const { permisos } = data;
      this.permissions = permisos.map((value) => ({
        ...value,
        filtrable: `${value.codigo?.toLowerCase() } ${ value.nombre?.toLowerCase() } ${
          value.descripcion?.toLowerCase()}`
      }));
      this.isLoading = false;
    },
    hide() {
      this.$refs.modalEditionRol.hide();
    }
  }
};
</script>

<style scoped>
.scroll-area {
  max-height: 80vh;
  overflow: auto;
}
</style>
